export * from './siteTypes';
export * from './eras';
export * from './findFilters';

export const BASE_MAPBOX_STYLE_URL =
  'mapbox://styles/jhrib/ckulpks8fg68l19ns3zyao7xn/draft';

export const WELCOME_SCREEN_MAPBOX_STYLE_URL =
  'mapbox://styles/mapbox/dark-v11';

export const DEFAULT_INITIAL_COORDS = {
  longitude: 14.4464964,
  latitude: 50.0701525,
  zoom: 10,
};

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiamhyaWIiLCJhIjoiY2t1bGR0aW1kMDhsczJ1dGhwMWRzdTQ2MCJ9.hlTq6_yVzr8fTTSWp1wO7w';

export const DRAWER_BLEEDING = 16;

/** Find situation keys stored in `find.situation_type` (AMCR find context). */
export const FIND_SITUATION_TYPES = [
  'field',
  'pasture',
  'forest',
  'natural topsoil',
  'cultural layer',
  'subsoil',
  'surface',
  'water',
  'building',
  'other',
];

/** Values assumed for AMCR-PAS export when the find does not set them. */
export const DEFAULT_FIND_SITUATION_TYPE = 'field';
export const DEFAULT_FIND_DEPTH_CM = 20;
export const DEFAULT_FIND_COUNT = 1;

/** AMCR project identifiers, e.g. `C-202602217` or `X-C-000026274`. */
export const AMCR_PROJECT_ID_PATTERN = /^[A-Z]+(?:-[A-Z]+)*-\d{6,12}$/;
export const AMCR_FINDER_NAME_PATTERN = /^[^,]+,\s*[^,]+$/;
export const AMCR_MAX_DEPTH_CM = 10000;
